import { createApiErrorHandler, useApiClient } from '@m43/core';
import { useMutation } from '@tanstack/react-query';
import { useToast } from '@cad-arc';
import { CadSearchResource, UnitStatusSearchExportRequest } from '@mark43/cad-api';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';

export function useExportUnitStatusSearchResultsMutation() {
    const apiClient = useApiClient();
    const toast = useToast();
    return useMutation((args: UnitStatusSearchExportRequest) => {
        return apiClient
            .request<CadSearchResource.UnitStatusSearchExport>({
                method: 'POST',
                url: 'cad_search/unit_status/export',
                data: args,
            })
            .catch(
                createApiErrorHandler(() => {
                    toast({
                        status: 'error',
                        description: errorOccurredWhile('exporting results'),
                    });
                })
            );
    });
}
